import type { FlowRoute, OnboardingProgress } from './flow-route-types.js';
import { isSectionComplete } from './onboarding-state.js';
import { paths } from './paths.js';
import { StepService } from './step-service.jsx';
import { StepActivate } from './step-activate.jsx';
import { StepWelcome } from './step-welcome.jsx';
import { StepStore } from './step-store.jsx';
import { StepDashboard } from './step-dashboard.jsx';
import { StepReview } from './step-review.jsx';
import { StepWhatsappConnect } from './step-whatsapp-connect.jsx';

const alwaysComplete = () => true;

export const flowRoutes: FlowRoute[] = [
  {
    path: paths.welcome,
    title: 'Boas-vindas',
    description:
      'Configure sua loja e conecte o WhatsApp oficial para testar a Marketside por 7 dias.',
    kind: 'entry',
    publicWhenSignedOut: true,
    View: StepWelcome,
    isComplete: alwaysComplete,
  },
  {
    path: paths.store,
    title: 'Mercado e localização',
    description: 'Informe o nome do mercado e confirme o endereço exato da loja.',
    kind: 'step',
    View: StepStore,
    isComplete: ({ draft }) => isSectionComplete(draft, 'store'),
  },
  {
    path: paths.service,
    title: 'Pagamento e entrega',
    description:
      'Informe os horários de atendimento, as formas de pagamento e como o cliente recebe o pedido.',
    kind: 'step',
    usesOwnNavigation: true,
    View: StepService,
    isComplete: ({ draft }) => isSectionComplete(draft, 'service'),
  },
  {
    path: paths.whatsappConnect,
    title: 'Conectar Meta Business',
    description: 'Entre com sua conta Meta Business e escolha o número que vai atender seus clientes.',
    kind: 'step',
    View: StepWhatsappConnect,
    isComplete: ({ connection }) => Boolean(connection?.phoneNumberId),
  },
  {
    path: paths.review,
    title: 'Revisão',
    description: 'Confira os dados da loja e do WhatsApp antes de iniciar o teste grátis.',
    kind: 'step',
    View: StepReview,
    isComplete: isReadyToActivate,
  },
  {
    path: paths.activate,
    title: 'Iniciar teste grátis',
    description: 'Ative o WhatsApp conectado e comece seu teste grátis de 7 dias.',
    kind: 'step',
    View: StepActivate,
    isComplete: ({ connection }) => connection?.status === 'activated',
  },
  {
    path: paths.dashboard,
    title: 'Painel',
    description:
      'Acompanhe seu teste grátis, o WhatsApp conectado e os dados da sua loja.',
    kind: 'dashboard',
    View: StepDashboard,
    isComplete: ({ connection }) => connection?.status === 'activated',
  },
];

function isReadyToActivate({ draft, connection }: OnboardingProgress): boolean {
  if (!isSectionComplete(draft, 'store')) {
    return false;
  }

  if (!isSectionComplete(draft, 'service')) {
    return false;
  }

  return Boolean(connection?.phoneNumberId);
}

export function routeForPath(path: string): FlowRoute {
  return flowRoutes.find((route) => route.path === path) ?? flowRoutes[0];
}
